export default __webpack_public_path__ + "22f1355737516def2eeb16d62eb65102.png";